import { useEffect } from 'react';

export default function usePortalDialog(open, onClose, dialogRef, triggerRef) {
    useEffect(() => {
        if (!open) return;
        const previous = document.activeElement;
        const trigger = triggerRef.current;
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        (dialogRef.current?.querySelector('input') || dialogRef.current?.querySelector('button'))?.focus();
        const onKeyDown = (event) => {
            if (!['Escape', 'Tab'].includes(event.key)) return;
            if (event.defaultPrevented) { event.stopImmediatePropagation(); return; }
            if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); onClose(); return; }
            if (event.key !== 'Tab') return;
            const nodes = Array.from(dialogRef.current?.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]') || []);
            const first = nodes[0], last = nodes[nodes.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); event.stopImmediatePropagation(); last?.focus(); }
            if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); event.stopImmediatePropagation(); first?.focus(); }
        };
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
            document.body.style.overflow = previousOverflow;
            (trigger || previous)?.focus();
        };
    }, [open, onClose, dialogRef, triggerRef]);
}
